/**
 * Enum of filter types used with advanced table filters.
 */
export enum AdvancedFilterType {
  Disabled = 'disabled',
  List = 'list',
  Status = 'status',
  Text = 'text'
}
